import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Settings, Save } from 'lucide-react';
import { ROLE_LABELS } from '../lib/utils';
import AdminSettings from '../components/AdminSettings';

export default function SettingsPage() {
  const { user, axiosAuth } = useAuth();
  const [form, setForm] = useState({ full_name: user.full_name || '', phone: user.phone || '', email: user.email || '' });
  const [saving, setSaving] = useState(false);
  const api = axiosAuth();

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put(`/users/${user.id}`, form);
      toast.success('Settings saved!');
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl space-y-6" data-testid="settings-page">
      <div><h1 className="text-2xl font-bold" style={{ fontFamily: 'Manrope' }}>Settings</h1><p className="text-muted-foreground text-sm mt-1">Manage your account</p></div>

      <Card className="border-0 shadow-sm rounded-2xl">
        <CardHeader className="pb-3"><CardTitle className="text-base font-semibold" style={{ fontFamily: 'Manrope' }}>Profile Information</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center gap-4 p-3 bg-muted/30 rounded-xl">
            <div className="w-14 h-14 rounded-full bg-teal-100 flex items-center justify-center text-xl font-bold text-teal-700">{user.full_name?.charAt(0)}</div>
            <div><p className="font-medium">{user.full_name}</p><p className="text-sm text-muted-foreground">{ROLE_LABELS[user.role]}</p></div>
          </div>
          <div className="space-y-1.5"><Label>Full Name</Label><Input value={form.full_name} onChange={e => setForm({...form, full_name: e.target.value})} className="h-11" data-testid="settings-name-input" /></div>
          <div className="space-y-1.5"><Label>Email</Label><Input value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="h-11" data-testid="settings-email-input" /></div>
          <div className="space-y-1.5"><Label>Phone</Label><Input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} className="h-11" data-testid="settings-phone-input" /></div>
          <Button onClick={handleSave} disabled={saving} className="bg-teal-600 hover:bg-teal-700 text-white rounded-full gap-2" data-testid="save-settings-button">
            <Save size={16} /> {saving ? 'Saving...' : 'Save Changes'}
          </Button>
        </CardContent>
      </Card>

      {user.role === 'admin' && <AdminSettings />}
    </div>
  );
}
